import axios from 'axios'
export default {
  namespaced: true,
  state: {
    interfaceGroupList: [],
    interfaceGroupIdList: {
      web: {
        auth: {
          titles: 169,
          labels: 170,
          buttons: 171,
        },
        commonElements: {
          buttons: 172,
          notifications: 173,
          pagination: 174,
          rules: 175,
          breadcrumbs: 235,
          text: 236,
          checkbox: 237,
          measure: 249,
        },
        error: {
          main: 179,
        },
        menu: {
          header: 1,
        },
        footer: {
          text: 2,
        },
        home: {
          main: 164,
        },
        pages: {
          buttons: 6,
        },
        planning: {
          pages: 9,
          orders: {
            table: 10,
          },
        },
        sales: {
          pages: 11,
          buttons: 12,
          project: {
            sections: 13,
            buttons: 19,
            'project-client': {
              sections: 22,
              buttons: 21,
              labels: 23,
              inputs: 24,
              tooltips: 25,
            },
            'schemes-documents': {
              buttons: 20,
              sections: 26,
              tooltips: 27,
              tables: 28,
              dialog: {
                delete: 245,
              },
            },
            'material-price': {
              tooltips: 30,
              tables: 29,
            },
            'planned-resources': {
              labels: 32,
              'time-period': {
                id: 34,
                labels: 35,
                inputs: 37,
                tooltips: 38,
                delete: 204,
              },
              responsibleEmployees: {
                id: 200,
                labels: 201,
                buttons: 202,
                delete: 203,
              },
              subscribers: 281,
            },
            price_offer_terms: {
              id: 246,
              labels: 247,
              tables: 248,
            },
          },
        },
        projects: {
          pages: 240,
          reports: {
            table: 274,
            dialogs: 275,
          },
        },
        statistic: {
          project: {
            text: 39,
            tables: 40,
          },
          employee: {
            text: 41,
            tables: 42,
          },
        },
        personnelDepartment: {
          pages: 43,
          employees: {
            dialogs: {
              employeeAdd: {
                id: 44,
                buttons: 45,
                labels: 46,
              },
              employeeInvitation: {
                id: 47,
                buttons: 50,
                inputs: 49,
                labels: 48,
              },
              employeePositionAppointment: {
                id: 51,
                buttons: 54,
                inputs: 53,
                labels: 52,
              },
            },
            card: 56,
          },
          employeesGroup: {
            id: 57,
            dialogs: {
              createEdit: {
                id: 58,
                labels: 59,
                buttons: 60,
              },
              delete: 205,
              additional_project: {
                id: 241,
                labels: 242,
                buttons: 243,
                delete: 244,
              },
            },
            tables: 61,
            sections: 62,
          },
        },
        setting: {
          pages: 63,
          personalArea: {
            sections: 64,
            labels: 65,
            buttons: 66,
            dialog: {
              new_address: 239,
            },
          },
          roles: {
            tables: 67,
            buttons: 68,
            labels: 69,
            accessTypes: {
              id: 70,
              planning: 71,
              sales: 72,
              timeControl: 73,
              employees: 74,
              personalArea: 75,
              setting: 76,
              inputs: 77,
            },
            dialogs: {
              delete: 182,
            },
          },
          users: {
            tables: 78,
            status: 238,
            dialogs: {
              edit: {
                id: 79,
                labels: 80,
                buttons: 81,
              },
              add: {
                id: 82,
                labels: 83,
                buttons: 84,
              },
              assignRole: {
                id: 85,
                buttons: 86,
                labels: 88,
              },
              delete: 181,
            },
          },
          interface: {
            common: 250,
            text: 262,
          },
          offer_agreement: {
            buttons: 251,
            tables: 252,
            labels: 253,
            tooltips: 259,
            dialog: {
              publish: {
                id: 254,
                buttons: 255,
              },
              confirm: {
                id: 256,
                buttons: 257,
              },
            },
          },
          businessSegment: {
            tables: 89,
            dialogs: {
              addEdit: {
                id: 90,
                labels: 91,
                buttons: 92,
                inputs: 93,
              },
              delete: 183,
            },
          },
          projectType: {
            tables: 94,
            dialogs: {
              addEdit: {
                id: 95,
                labels: 96,
                buttons: 97,
                inputs: 98,
              },
              delete: 184,
            },
          },
          workTypeCategory: {
            tables: 100,
            dialogs: {
              addEdit: {
                id: 101,
                labels: 102,
                buttons: 104,
                inputs: 103,
              },
              delete: 185,
            },
          },
          workType: {
            tables: 105,
            dialogs: {
              addEdit: {
                id: 106,
                labels: 107,
                // inputs: 103,
                buttons: 108,
              },
              delete: 186,
            },
          },
          workExtraType: {
            tables: 109,
            dialogs: {
              addEdit: {
                id: 110,
                labels: 111,
                // inputs: 103,
                buttons: 112,
              },
              delete: 187,
            },
          },
          clients: {
            tables: 113,
            dialogs: {
              addEdit: {
                id: 114,
                labels: 115,
                buttons: 116,
              },
              address: {
                id: 117,
                labels: 118,
                buttons: 119,
                checkbox: 120,
              },
              delete: 189,
            },
            address: {
              id: 124,
              dialogs: {
                addEdit: {
                  id: 125,
                  buttons: 126,
                },
                delete: 190,
              },
            },
            contacts: {
              id: 127,
              dialogs: {
                addEdit: {
                  id: 128,
                  buttons: 129,
                },
                delete: 191,
              },
            },
            persons: {
              id: 130,
              dialogs: {
                addEdit: {
                  id: 131,
                  buttons: 132,
                },
                delete: 192,
              },
            },
            offices: {
              id: 133,
              dialogs: {
                addEdit: {
                  id: 134,
                  buttons: 135,
                },
                delete: 193,
              },
            },
          },
          region: {
            tables: 137,
            dialogs: {
              addEdit: {
                id: 138,
                labels: 139,
                buttons: 140,
              },
              delete: 194,
            },
          },
          employeeRoles: {
            tables: 141,
            dialogs: {
              addEdit: {
                id: 142,
                labels: 143,
                buttons: 144,
              },
              delete: 195,
            },
          },
          schemeType: {
            tables: 146,
            dialogs: {
              addEdit: {
                id: 147,
                labels: 148,
                buttons: 149,
              },
              delete: 196,
            },
          },
          documentType: {
            tables: 150,
            dialogs: {
              addEdit: {
                id: 151,
                labels: 152,
                buttons: 153,
              },
              delete: 197,
            },
          },
          workArea: {
            tables: 154,
            dialogs: {
              addEdit: {
                id: 155,
                labels: 156,
                buttons: 157,
              },
              delete: 198,
            },
          },
          schemeСlass: {
            tables: 158,
            dialogs: {
              addEdit: {
                id: 159,
                labels: 160,
                buttons: 161,
              },
              delete: 199,
            },
          },
          structureCompany: {
            titles: 265,
            buttons: 266,
            labels: 267,
          },
          freeDocuments: {
            pages: 293,
            tables: 268,
            dialogs: {
              titles: 270,
              labels: 271,
              buttons: 272,
            },
          },
          settingCompany: {
            all: 279,
          },
          pushNotifications: {
            main: 282,
            statuses: 283,
            dialogs: 284,
            types: 285,
            triggers: 286,
          },
          settingsFinance: 294
        },
        finance: {
          pages: 288,
          salary: 289,
          period: 290,
          invoice: 291,
          invoice_status: 292,
        },
        chat: {
          all: 295
        }
      },
      mob: {
        menu: {
          buttons: 99,
        },
        login: {
          buttons: 166,
          inputs: 167,
          labels: 168,
        },
        registration: {
          titles: 206,
          labels: 207,
          buttons: 208,
        },
        restore: {
          buttons: 176,
          inputs: 178,
          labels: 177,
        },
        invitation: {
          titles: 213,
          labels: 214,
          buttons: 215,
        },
        personalArea: {
          titles: 209,
          labels: 210,
          sections: 211,
          buttons: 212,
        },
        modal: {
          addPhoto: 224,
          common: 226,
        },
        workingTime: {
          titles: 216,
          text: 217,
          buttons: 218,
          report: {
            titles: 219,
            sections: 221,
            labels: 222,
            buttons: 223,
          },
        },
        agreement: {
          labels: 260,
          buttons: 261,
        },
        projects: {
          sections: 263,
        },
        calendar: {
          labels: 273,
        },
        push: {
          labels: 287,
        },
      },
      mail: {
        invite: {
          titles: 227,
          text: 228,
          buttons: 229,
          footer: 230,
        },
        password: {
          titles: 231,
          text: 232,
          buttons: 233,
          footer: 234,
        },
        offer: {
          titles: 276,
          buttons: 277,
          footer: 278,
        },
        report_sign: {
          fields: 280,
        },
      },
      projects_status: {
        status: 31,
      },
    },
  },
  mutations: {
    setInterfaceGroupList(state, payload) {
      state.interfaceGroupList = payload
    },
  },
  getters: {
    interfaceGroupList: (state) => state.interfaceGroupList,
    interfaceGroupIdList: (state) => state.interfaceGroupIdList,
  },
  actions: {
    onInterfaceGroupList({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/interfaceGroup',
          method: 'GET',
        })
          .then((resp) => {
            commit('setInterfaceGroupList', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onInterfaceGroupCreate({ dispatch, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/interfaceGroup',
          data,
          method: 'post',
        })
          .then((resp) => {
            dispatch('onInterfaceGroupList')
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onInterfaceGroupUpdate({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/interfaceGroup/' + id + '/field',
          method: 'PUT',
          data,
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onInterfaceGroupDelete({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/interfaceGroup/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
